import { useMounted } from './use-mounted';
import { useCallback, useState } from 'react';
const inc = (_) => _ + 1;
const dec = (_) => _ - 1;
export function useConcurrencyControl(maxConcurrency = 1) {
    const mounted = useMounted();
    /**
     * using useState instead of useRef: UI may infer pending/blocked from it
     */
    const [running, setRunning] = useState(0);
    const runWithLock = useCallback((foo) => {
        if (mounted.current && running < maxConcurrency) {
            setRunning(inc);
            return foo(mounted).finally(() => mounted.current && setRunning(dec));
        }
        return Promise.reject('max concurrency exceeded');
    }, [running, maxConcurrency]);
    return [runWithLock, running];
}
//# sourceMappingURL=use-concurrency-control.js.map